import { createAction, createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';
import { INoteTemplate } from 'shared/interfaces/noteTemplate.interface';

const sortNoteTemplates = (templates: INoteTemplate[]) => {
  return templates.sort((a, b) => a.noteTitle.localeCompare(b.noteTitle));
};

export const getNoteTemplates = createAction(
  'noteTemplates/GET_NOTE_TEMPLATES'
);

export const deleteNoteTemplate = createAction(
  'noteTemplates/DELETE_NOTE_TEMPLATES',
  (payload) => ({
    payload
  })
);

// Slices

const noteTemplatesSlice = createSlice({
  name: 'noteTemplates',
  initialState: initialStore.noteTemplates,
  reducers: {
    createNoteTemplate: (state, _data) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    updateNoteTemplate: (state, _data) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setNoteTemplate: (state, { payload }) => {
      (state.noteTemplates as INoteTemplate[]) = sortNoteTemplates([
        ...state.noteTemplates,
        payload
      ]);
      state.isLoading = false;
    },
    setNoteTemplates: (state, { payload }) => {
      (state.noteTemplates as INoteTemplate[]) = sortNoteTemplates(payload);
      state.isLoading = false;
    },
    removeNoteTemplate: (state, { payload }) => {
      state.noteTemplates = state.noteTemplates.filter(
        ({ id }) => id !== payload
      );
    },
    setUpdatedNoteTemplate: (state, { payload }) => {
      (state.noteTemplates as INoteTemplate[]) = sortNoteTemplates([
        ...state.noteTemplates.filter(({ id }) => id !== payload.id),
        payload
      ]);
      state.isLoading = false;
    }
  }
});

export const {
  createNoteTemplate,
  setNoteTemplate,
  setNoteTemplates,
  removeNoteTemplate,
  updateNoteTemplate,
  setUpdatedNoteTemplate
} = noteTemplatesSlice.actions;

export const { reducer } = noteTemplatesSlice;

// Selectors
export const getNoteTemplatesSelector = (state: IState) =>
  state && state.noteTemplates.noteTemplates;

export const getNoteTemplatesLoadingSelector = (state: IState) =>
  state && state.noteTemplates.isLoading;
